import React from 'react';

interface ProposalOptionOverviewProps {
    propertyData: any;
}

export default function ProposalOptionOverviewCardDetails({ propertyData }: ProposalOptionOverviewProps) {
    return (
        <>
            {propertyData?.officeOptionOverviews?.length ? <table
                width="100%"
                cellPadding="0"
                cellSpacing="0"
                style={{ marginBottom: "30px" }}
            >
                <tbody>

                    <tr>
                        <td>
                            <span
                                style={{
                                    fontSize: "22px",
                                    color: "#8FA9D4",
                                    fontWeight: 700,
                                }}
                            >
                                <u> OPTION OVERVIEW</u>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td height="12"></td>
                    </tr>
                    <tr>
                        <td
                            style={{
                                position: 'relative',
                            }}
                        >
                            <div style={{
                                padding: "20px",
                                borderRadius: "12px", position: 'relative', zIndex: 1, backgroundColor: "#F8F5FA", minHeight: "200px",
                            }}>
                                <table
                                    width="100%"
                                    cellPadding="0"
                                    cellSpacing="0"
                                >
                                    <tbody>
                                        <tr>
                                            <td width="50%" valign="top">
                                                <ul
                                                    style={{
                                                        listStyleType: "none",
                                                        padding: "0",
                                                        marginBottom: "0",
                                                        columns: "2",
                                                    }}
                                                >
                                                    {propertyData.officeOptionOverviews.map(
                                                        (officeOptionOverview: {
                                                            attrName: string;
                                                            attrOptionValue: string;
                                                        }) => (
                                                            <li
                                                                style={{
                                                                    color: "#5E5E5E",
                                                                    fontSize: "14px",
                                                                    marginBottom:
                                                                        "9px",
                                                                    lineHeight:
                                                                        "25px",
                                                                }}
                                                            >
                                                                <u
                                                                    style={{
                                                                        color:
                                                                            "#00134F",
                                                                    }}
                                                                >
                                                                    {
                                                                        officeOptionOverview.attrName
                                                                    }{" "}
                                                                    :
                                                                </u>{" "}
                                                                {
                                                                    officeOptionOverview.attrOptionValue
                                                                }
                                                            </li>
                                                        )
                                                    )}
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div
                                style={{
                                    width: "100%",
                                    height: "20px",
                                    background:
                                        "radial-gradient(black, #000000a3)",
                                    position: "absolute",
                                    left: "-50%",
                                    bottom: "-10px",
                                    zIndex: 0,
                                    borderRadius: "147px",
                                    filter: "blur(7px)",
                                    transform:
                                        "translateX(50%) scaleY(0.2)",
                                }}
                            ></div>
                        </td>
                    </tr>
                </tbody>
            </table> : ''}
        </>
    );
}
